import React from 'react';
import { Link } from 'react-router-dom';
import { images } from '../../data/images';
const pillars = [{
  title: 'Wat het is',
  text: 'Herkomst en samenstelling, zonder omhaal.'
}, {
  title: 'Wat het doet',
  text: 'Eerlijke werking, geen wonderclaims.'
}, {
  title: 'Hoe je het gebruikt',
  text: 'Bij elk product een helder ritueel.'
}];
export function BrandStrip() {
  return <section className="mx-auto max-w-7xl px-5 pb-20 lg:px-8 lg:pb-28" data-id="element-41" data-mp="3shai5oqqp1t6">
      <div className="grid overflow-hidden rounded-3xl bg-ink text-canvas lg:grid-cols-2" data-id="element-42" data-mp="3sj4re5snf5hf">
        <img src={images.story} alt="Twee generaties mengen henna in een terracotta schaal" className="h-full min-h-[320px] w-full object-cover" data-id="element-43" data-mp="18wem93e4fg8" />
        <div className="flex flex-col justify-center px-7 py-12 sm:px-12 lg:px-16" data-id="element-44" data-mp="abxh7zt1rof5">
          <p className="text-sm font-medium text-[#E7B79F]" data-id="element-45" data-mp="273xmf3j1our7">Pure. Clear. Proven.</p>
          <h2 className="mt-3 text-3xl font-semibold tracking-display sm:text-4xl" data-id="element-46" data-mp="27621mhme9g6s">Een product hoef je niet mooier te maken dan het is.</h2>
          <ul className="mt-8 space-y-4" data-id="element-47" data-mp="skfkjfpl20l6">
            {pillars.map(p => <li key={p.title} className="border-t border-canvas/15 pt-4" data-id="element-48" data-mp="ntp9pmye15j3">
                <p className="font-semibold" data-id="element-49" data-mp="nrmbwgqzu83t">{p.title}</p>
                <p className="text-sm text-canvas/60" data-id="element-50" data-mp="jsnd7dvuv7kt">{p.text}</p>
              </li>)}
          </ul>
          <Link to="/over-amira" className="mt-10 inline-flex h-12 w-fit items-center whitespace-nowrap rounded-full bg-canvas px-6 text-sm font-medium text-ink transition-colors duration-150 hover:bg-surface" data-id="element-51" data-mp="eubyaoqpe6vq">
            Lees het verhaal van Amira
          </Link>
        </div>
      </div>
    </section>;
}